import { selectUserDetails } from "../../redux/slices/auth"
import { useFetchBillingConfigQuery } from "../../redux/queries"
import { useAppSelector } from "./use-store"

/**
 * `orgIdOverride` scopes the check to a specific org (the brand being edited)
 * instead of the viewer's own org — needed whenever an administrator manages
 * an integration on behalf of a different org, since that org's billing
 * entitlements, not the admin's, decide what should unlock.
 */
export const useHasBillingFeature = (
  featureKey: string,
  orgIdOverride?: string
) => {
  const user = useAppSelector(selectUserDetails)
  const orgId = orgIdOverride || user?.org?.id || ""

  const { data, isLoading } = useFetchBillingConfigQuery(
    { org_id: orgId },
    { skip: !orgId }
  )

  const hasFeature = !!data?.[0]?.details?.features?.includes(featureKey)

  return { hasFeature, isLoading }
}
